export default "__VITE_ASSET__CBYQVVXC__"